/* eslint-env globals */
import $ from 'jquery';

import 'intersection-observer';

import i18next from './lang/i18n.js';

import helper from './utils/helper.js';
import popup from './popup.js';
import mobileMenu from './mobile-menu.js';
import { Calculator } from './calc.js';

import LinkSanitizer from './utils/linksanitizer.js';
import Popup from './popup.js';
import MobileMenu from './mobile-menu.js';
import DeliveryPrices from './delivery-prices.js';


import 'slick-carousel-latest';
import 'slick-carousel-latest/slick/slick.css';
import 'slick-carousel-latest/slick/slick-theme.css';

// Add the following line to extend the prototype of slick

$.noConflict();
window.$ = $;

function addSearchIconToInput(pluginPath) {
  const $trackNumberSearchInput = $(
    '#ewd-otp-tracking-form .pure-control-group:nth-of-type(1), .ewd-otp-form-identifier'
  );

  if ($trackNumberSearchInput.length === 0) return;
  const searchIconUrl = `${pluginPath}assets/img/search-icon.png`;
  const searchIcon = `<img src="${searchIconUrl}" alt="search icon" class="light-global__search-icon" />`;
  $trackNumberSearchInput.append(searchIcon);
  // set placeholder text
  $trackNumberSearchInput
    .find('input')
    .attr('placeholder', 'Введите номер отслеживания TH... или PU......');
}

function addStyleToTrackingResults() {
  if ($('.ewd-otp-tracking-results').length === 0) return;
  $('.ewd-otp-tracking-results').css('background-color', '#ffffff');
  $('.ewd-otp-tracking-results').css('box-shadow', '0px 0px 10px 4px rgba(0, 0, 0, 0.15)');
}
// hide nearest parent .ewd-otp-tracking-results if .ewd-otp-ajax-results html is empty
function hideEmptyResults() {
  if ($('.ewd-otp-ajax-results').length === 0) return;
  if ($('.ewd-otp-ajax-results').html().trim() === '') {
    $('.ewd-otp-ajax-results').closest('.ewd-otp-tracking-results').hide();
    addStyleToTrackingResults();
  }
}
function init(globals) {
  addSearchIconToInput(globals.pluginPath);
  hideEmptyResults();
  const $calculator = $('[class^="light-global-logistics-calc-"]');
  if ($calculator.length !== 0) {
    // Add plugin version as a cache-busting parameter
    const jsonUrl = `${globals.pluginPath}data.json?ver=${globals.pluginVersion}`;

    // get data from data.json file and pass it to the Calculator
    $.getJSON(jsonUrl, function (data) {
      window.jsonData = data;

      $calculator.each(function () {
        new Calculator(window.jsonData, $(this));
      });
    });
  }

  const $countrySelector = $('#country-selector');
  if ($countrySelector.length !== 0) {
    if(!window.jsonData) {
      // Add plugin version as a cache-busting parameter
      const jsonUrl = `${globals.pluginPath}data.json?ver=${globals.pluginVersion}`;

      $.getJSON(jsonUrl, function (data) {
        window.jsonData = data;
        const deliveryPrices = new DeliveryPrices(window.jsonData);
      });
    }
    else {
      const deliveryPrices = new DeliveryPrices(window.jsonData);
    }
  }

  $('#ewd-otp-tracking-form, form.ewd-otp-tracking-form').on('submit', function () {
    addStyleToTrackingResults();
  });

  const linkSanitizer = new LinkSanitizer();
  linkSanitizer.init();

  console.log('init script.js');
}

// promise that will run init after i18next is ready
i18next.on('initialized', () => {
  // init(typeof globals === 'undefined' ? {} : globals);
  init(globals);
  console.log('i18next initialized');
  const texts = {
    '#info-box-delivery': 'Доставим в самые короткие сроки от 5 дней',
    '#info-box-warehouse': 'Принимаем ваши заказы из магазинов или от поставщиков и сортируем',
    '#info-box-customs':
      'Всю документальную часть берем на себя, подготовим необходимые документы без вашего участия',
    '#info-box-support': 'Решаем все возникающие у таможенных представителей вопросы',
    '#info-box-calculator': 'Опытные сотрудники подскажут лучшее решение в вашей ситуации',
    '#info-box-justice': 'Контролируем процесс на каждом этапе от заключения договоров до оплат',
  };

  new Popup(texts);
  new MobileMenu();
});